import getAllFiles from '@/helper/getAllFiles';

const allTranslations = getAllFiles(require.context('./', true, /\.(js)$/i));
const allTransaltionsList = allTranslations.map((item) => import(`./${item}`));

export default allTransaltionsList;
